import { IGetSystemPropertyResponse } from '../types'
import { BOWTIE_BASE_URL, BOWTIE_REST_ENDPOINTS } from '../utils/constants'

export const getSystemProperty = async (): Promise<IGetSystemPropertyResponse> => {
    return fetch(`${BOWTIE_BASE_URL}/${BOWTIE_REST_ENDPOINTS.systemProperty}/`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = null
        }

        if (data.ok) {
            return jsonData as IGetSystemPropertyResponse
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
        }
    })
}
